import { useTranslation } from "react-i18next";
import { Package, Settings, Award, Wrench, Boxes, Recycle } from "lucide-react";

const ICONS = [Package, Settings, Award, Wrench, Boxes, Recycle];

export default function Services() {
  const { t } = useTranslation();
  const items = t("services.items", { returnObjects: true });
  return (
    <div className="mx-auto max-w-6xl px-6 py-16">
      <div className="text-xs font-semibold uppercase tracking-[0.25em] text-teal-700">Capabilities</div>
      <h1 className="mt-3 text-4xl font-bold tracking-tight text-[#0F2942] sm:text-5xl" style={{ fontFamily: "Outfit, sans-serif" }}>{t("services.title")}</h1>
      <p className="mt-3 max-w-2xl text-lg text-slate-600">{t("services.subtitle")}</p>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div key={i} data-testid={`service-card-${i}`} className="rounded-xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg">
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#0F2942]">
                <Icon className="h-5 w-5 text-teal-300" />
              </div>
              <h3 className="mt-5 text-lg font-bold text-[#0F2942]" style={{ fontFamily: "Outfit, sans-serif" }}>{it.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{it.d}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
